/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-07-27 19:21:22
 * @LastEditors: 张印 hbzyin@163.com
 * @LastEditTime: 2023-08-19 09:09:42
 * @FilePath: /mall-fe/src/views/Mobile/components/ProductCategory.tsx
 * @Description: 移动端商品分类列表组件
 *
 */
import IconFont from 'comps/IconFont';
import PriceTip from 'comps/PriceTip';
import { getHref } from 'libs/urls';
import { colorRgb, generateUniqueKey, isArray } from 'libs/utils';
import Link from 'next/link';
import { useState } from 'react';
import { Flex, Tabs } from 'react-vant';
import ImageRenderer, { ResourcesFrom } from './ImageRenderer';
const length = 3;
function ProductCategory(props: { product: FloorsProps }) {
  const {
    children: productList = [],
    title,
    description,
    mobileBackgroundColor,
    mobileTextColor,
  } = props.product;
  const size = {
    width: 100,
    height: 100,
  };
  const [activeIndex, setActiveIndex] = useState<number | string>(0);
  const productListEle = productList.map(({ title, id, skuList = [] }) => (
    <Tabs.TabPane title={title} key={id}>
      <Flex gutter={10}>
        {generateUniqueKey(skuList.slice(0, length)).map((sku) => {
          const { __key, imgPaths, productTagTitleList, name, salesPrice } = sku;
          return (
            <Flex.Item span={8} key={__key}>
              <div className="product-content-preview">
                <ImageRenderer
                  path={isArray(imgPaths) ? imgPaths[0] : null}
                  thumbnail={{ compress: true, ...size }}
                  resourcesFrom={ResourcesFrom.publicCloud}
                  href={`/product/detail?id=${sku.sysNo}`}
                />
              </div>
              <div className="product-content-info">
                <div className="product-content-info-name">
                  {isArray(productTagTitleList) && (
                    <span className="name-tag">{productTagTitleList[0].tagName}</span>
                  )}
                  {name}
                </div>
                <PriceTip price={salesPrice} />
              </div>
            </Flex.Item>
          );
        })}
      </Flex>
    </Tabs.TabPane>
  ));

  return (
    <div className="product">
      <div className="product-header">
        <div className="product-header-left">
          <h2 className="product-title">{title}</h2>
          <span className="product-desc">{description}</span>
        </div>
        {!!productList[Number(activeIndex)]?.link && (
          <Link href={getHref(productList[Number(activeIndex)]?.link)}>
            <a className="product-header-right">
              <span>更多</span>
              {IconFont({
                className: 'icon-next',
                style: { fontSize: '12px' },
              })}
            </a>
          </Link>
        )}
      </div>
      <Tabs
        lineWidth={22}
        lineHeight={3}
        titleActiveColor="#333"
        titleInactiveColor="#666"
        background="none"
        color="#0080ff"
        swipeable
        swipeThreshold={length}
        onChange={setActiveIndex}
      >
        {productListEle}
      </Tabs>
      <style jsx>
        {`
          .product {
            padding: 12px 0;
            background: linear-gradient(
              180deg,
              ${mobileBackgroundColor} 0%,
              #ffffff 100%
            );
            box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            margin-bottom: 12px;
          }

          .product :global(.rv-tabs__wrap) {
            height: 30px;
            margin-bottom: 12px;
          }
          .product :global(.rv-tabs__nav) {
            padding-left: 0;
            padding-right: 0;
          }
          .product :global(.rv-tab) {
            flex: none;
            padding: 0 12px !important;
          }
          .product :global(.rv-swiper__slide) {
            padding-right: 12px;
            padding-left: 12px;
          }
          .product :global(.rv-tabs__line) {
            border-radius: 12px;
          }
          .product :global(.product-content-preview) {
            height: ${size.height}px;
            overflow: hidden;
            background: #fff;
            border-radius: 12px;
          }
          .product :global(.product-content-info) {
            margin-top: 10px;
          }
          .product :global(.product-content-info-name) {
            height: 34px;
            font-size: 11px;
            color: #333;
            line-height: 17px;
            overflow: hidden;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
          }
          .product :global(.name-tag) {
            background: linear-gradient(90deg, #f31e10 0%, #f26255 102.08%);
            border-radius: 1px;
            color: #fff;
            padding: 2px;
            margin-right: 3px;
          }

          .product :global(.price) {
            font-family: "DIN";
            font-weight: 500;
            font-size: 10px;
            line-height: 22px;
            color: #ff4747;
          }

          .product-header {
            display: flex;
            justify-content: space-between;
            padding: 0 12px 12px 12px;
            font-size: 12px;
            color: #26a639;
          }

          .product-header-left {
            display: flex;
            align-items: center;
          }

          .product-title {
            font-family: "FZZhengHeiS-DB-GB";
            font-weight: bold;
            font-size: 16px;
            line-height: 20px;
            color: #24201d;
            margin: 0;
          }

          .product-desc {
            font-family: "PingFang SC";
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 17px;
            color: ${mobileTextColor || '#24201d'};
            margin-left: 8px;
          }

          .product-header-right {
            padding: 2px 5px 2px 10px;
            border-radius: 10px;
            background: ${
              mobileTextColor ? colorRgb(mobileTextColor.replace(/\s*/g, ''), 0.1) : '#fff'
            };
            color: ${mobileTextColor};
          }
        `}
      </style>
    </div>
  );
}

export default ProductCategory;
